import BasePage from '@/found/components/table_page';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {
      params: {
        scanSupplyUserName: this.paramsProps.scanSupplyUserName,
      },
    };
  },
  methods: {

  },
  created() {
    this.getConfigList('detail-list');
  },
};
